export const noEventDayStatus = "tile"

export const SessionStatuses = Object.freeze({
  Pending: "pending",
  Finished: "finished",
  ReportReady: "report_ready",
  ReportSent: "report_sent",
  Cancelled: "cancelled",
  CancelledNoShow: "cancelled_no_show",
})

// Uppercase version for backward compatibility
export const SESSION_STATUS = Object.freeze({
  PENDING: SessionStatuses.Pending,
  FINISHED: SessionStatuses.Finished,
  CANCELLED: SessionStatuses.Cancelled,
  CANCELLED_NO_SHOW: SessionStatuses.CancelledNoShow,
})

export const finalStatuses = Object.freeze([
  SessionStatuses.Finished,
  SessionStatuses.Cancelled,
  SessionStatuses.CancelledNoShow,
])

export const SessionActions = Object.freeze({
  Update: "update",
  Destroy: "destroy",
  Finish: "finish",
  Cancel: "cancel",
  Pend: "pend",
})

// Action mapping for the session status - maintain uppercase keys for compatibility
export const SESSION_STATUS_ACTION = Object.freeze({
  FINISHED: SessionActions.Finish,
  PENDING: SessionActions.Pend,
  CANCELLED: SessionActions.Cancel,
  CANCELLED_NO_SHOW: SessionActions.Cancel,
})

export const SESSION_STATUS_OPTIONS = Object.freeze([
  {
    id: SESSION_STATUS.PENDING,
    title: "Pending",
    description: "The session has not happened yet",
    icon: null,
  },
  {
    id: SESSION_STATUS.FINISHED,
    title: "Finished",
    description: "At least one student attended the session",
    icon: null,
  },
  {
    id: SESSION_STATUS.CANCELLED,
    title: "Canceled",
    description: "The session was canceled by agreement",
    icon: null,
  },
  {
    id: SESSION_STATUS.CANCELLED_NO_SHOW,
    title: "No Show",
    description: "No students attended the session",
    icon: null,
  },
])

export const ReportStatuses = Object.freeze({
  Sent: "report_sent",
  Submitted: "report_submitted",
  Overdue: "report_overdue",
  Planned: "planned",
  InProgress: "in_progress",
  NoSessions: "no_sessions",
  Abandoned: "report_abandoned",
})

export const cancelledStatuses = Object.freeze(finalStatuses.filter(status => status !== SessionStatuses.Finished))

export const reportValidationStatuses = Object.freeze([ReportStatuses.InProgress, ReportStatuses.Overdue])

export const routerOptions = Object.freeze({ basename: "/schedules" })

export const ValidationNames = Object.freeze({
  Agenda: "agenda",
  NextSteps: "nextSteps",
  StrengthsChallenges: "strengthsChallenges",
  ProgramProgresses: "programProgresses",
  StudentStrengthsChallenges: "studentStrengthsChallenges",
  StudentProgramProgresses: "studentProgramProgresses",
  GroupProgressInfo: "groupProgressInfo",
  GroupProgressInfoInvalid: "groupProgressInfoInvalid",
  AllSessionFinished: "allSessionFinished",
  AttendanceWarnings: "attendanceWarnings",
  CommonInvalid: "commonInvalid",
  EmptySessions: "emptySessions",
  FutureReport: "futureReport",
})

export const DayActions = Object.freeze({
  CreateSession: "create_session",
})

export const ScheduleActions = Object.freeze({
  Update: "update",
  ManageSessions: "manage_sessions",
})

export const SessionTitles = Object.freeze({
  [SessionStatuses.Pending]: "Pending",
  [SessionStatuses.Finished]: "Finished",
  [SessionStatuses.Cancelled]: "Canceled",
  [SessionStatuses.CancelledNoShow]: "No show",
})

export const MeetingFormatTitles = Object.freeze({
  online: "Online",
  offline: "Offline",
  pencil_spaces: "Pencil Spaces",
})

export const EducatableTypes = Object.freeze({
  Group: "OpeningGroup",
  Student: "Student",
})

export const ConnectionLevels = Object.freeze({
  Main: "main",
  Substitute: "substitute",
})

export const AssignmentTypes = {
  PROGRAM_ASSESSMENT: "ProgramAssessment",
  LESSON: "Lesson",
}
